import { render, staticRenderFns } from "./CeoDashboard.vue?vue&type=template&id=45af471c&scoped=true&"
import script from "./CeoDashboard.vue?vue&type=script&lang=js&"
export * from "./CeoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CeoDashboard.vue?vue&type=style&index=0&id=45af471c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af471c",
  null
  
)

export default component.exports